<template>
    <div>
      <base-screen>
        <el-form
          size="small"
          :inline="true"
          :model="screenData"
          ref="screenForm"
          @keydown.native.enter="screenSubmit">
          <el-form-item label="订单编号：" prop="orderNo">
            <el-input type="text"
                      v-model="screenData.orderNo"
                      placeholder="请输入订单编号"
                      autocomplete="off">
            </el-input>
          </el-form-item>
          <el-form-item label="服务客户：" prop="name">
            <el-input type="text" v-model="screenData.name" placeholder="请输入客户名称"
                      autocomplete="off">
            </el-input>
          </el-form-item>
          <el-form-item label="联系方式：" prop="phone">
            <el-input type="text" v-model="screenData.phone" placeholder="请输入联系方式"
                      autocomplete="off">
            </el-input>
          </el-form-item>
          <el-form-item label="订单状态：" prop="finishState">
            <el-select v-model="screenData.finishState" placeholder="请选择订单状态">
              <el-option label="未支付" value="5"></el-option>
              <el-option label="已支付" value="7"></el-option>
              <el-option label="已退款" value="11"></el-option>
              <el-option label="已评价" value="12"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="完成时间：">
            <el-date-picker
              v-model="dateRange"
              type="datetimerange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="客户评价：" prop="evaluate">
            <el-select v-model="screenData.evaluate" placeholder="请选择服务评价">
              <el-option label="非常满意" value="1"></el-option>
              <el-option label="很满意" value="2"></el-option>
              <el-option label="还不错" value="3"></el-option>
              <el-option label="一般" value="4"></el-option>
              <el-option label="差" value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button class="btn-screen" type="primary" @click="screenSubmit">查询</el-button>
            <el-button type="text" @click="resetScreen">重置</el-button>
            <el-button
              class="btn-screen excel-left"
              type="primary"
              @click="exportExcel"
              icon="el-icon-download"
              :loading="exportLoading">
              导出excel
            </el-button>
          </el-form-item>
        </el-form>
      </base-screen>
      <div class="page-box">
        <el-table
          :data="tableData"
          v-loading="loading">
          <el-table-column
            prop="orderNo"
            label="订单编号"
            width="130">
          </el-table-column>
          <el-table-column
            prop="name"
            label="客户名称"
            width="120">
            <div class="link"
                 slot-scope="{row}"
                 @click="$emit('order-view','order-detail', row.orderNo)">
              {{ row.name }}
            </div>
          </el-table-column>
          <el-table-column
            prop="phone"
            label="联系方式"
            width="120">
          </el-table-column>
          <el-table-column
            prop="serviceName"
            label="预约服务">
          </el-table-column>
          <el-table-column
            prop="orderTime"
            label="预约时间"
            width="100">
          </el-table-column>
          <el-table-column
            prop="endTime"
            label="完成时间"
            width="100">
          </el-table-column>
          <el-table-column
            prop="orderAmount"
            label="订单金额"
            width="100">
          </el-table-column>
          <el-table-column
            prop="leaderName"
            label="负责人"
            width="100">
          </el-table-column>
          <el-table-column
            prop="state"
            label="订单状态"
            width="80">
            <div slot-scope="{row}">
              <icon-svg :icon-class="`${orderStatus[row.orderState].icon}`"></icon-svg>
              {{ orderStatus[row.orderState].name}}
              <div v-if="row.refundFlag" class="state-rem">
                已退款
              </div>
            </div>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="120">
            <template slot-scope="{row}">
              <template v-if="row.orderState === '5'" >
                <el-button class="link" type="text" v-pms="'settlementOrder'" @click="$emit('order-view','order-settlement', row.orderFormId)">结算</el-button>
              </template>
              <template v-else>
                <el-button class="link" type="text" v-pms="'evaluation'" @click="evaluation(row)">评价</el-button>
                <el-button class="link" type="text" v-pms="'visit'" @click="visit(row)">回访</el-button>
                <el-button class="link" type="text" v-pms="'visit'" @click="refund(row)">退款</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.pageNum"
          :page-sizes="[10, 15, 20]"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total">
        </el-pagination>
      </div>
      <order-finish-evaluate
        :dialogEvaluate = 'dialogEvaluate'
        :entity = 'entity'
        @dialogEvaluate = 'dialogEvaluate = false'
        @flush = 'getData'>
      </order-finish-evaluate>
      <order-finish-visit
        :dialogVisit = 'dialogVisit'
        :entity = 'entity'
        @dialogVisit = 'dialogVisit = false'
        @flush = 'getData'>
      </order-finish-visit>
      <order-finish-refund
        :dialogRefund = 'dialogRefund'
        :entity = 'entity'
        @dialogRefund = 'dialogRefund = false'
        @flush = 'getData'>
      </order-finish-refund>
    </div>
</template>

<script>
import {order, employee} from '@/api'
import OrderFinishEvaluate from './OrderFinishEvaluate'
import OrderFinishVisit from './OrderFinishVisit'
import OrderFinishRefund from './OrderFinishRefund'
import {orderStatus, dateRangeShortcut} from '@/utils/constant'
import dayjs from 'dayjs'

export default {
  name: 'OrderLoading',
  components: {
    'order-finish-evaluate': OrderFinishEvaluate,
    'order-finish-visit': OrderFinishVisit,
    'order-finish-refund': OrderFinishRefund
  },
  props: {
    param: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      employees: [],
      employeeAll: [],
      detailShow: false,
      loading: false,
      orgCode: this.$store.state.user.orgCode,
      screenData: {
        orderNo: '',
        orgCode: this.$store.state.user.orgCode,
        name: '',
        phone: '',
        leaderId: '',
        serviceId: '',
        offBeginDate: '',
        offEndDate: '',
        orderType: 'finish',
        finishState: ''
      },
      page: {
        pageSize: 10,
        pageNum: 1
      },
      dateRange: '', //
      tableData: [],
      payWays: [],
      pickerOptions: {
        shortcuts: dateRangeShortcut
      },
      employeeLoading: false,
      dialogEvaluate: false,
      dialogVisit: false,
      dialogRefund: false,
      exportLoading: false,
      orderFormId: '',
      entity: {},
      orderStatus
    }
  },
  watch: {
    dateRange (val) {
      this.setScreeData(val)
    }
  },
  created () {
    this.getData()
    this.getEmployeeAll('')
  },
  methods: {
    changeEvent (value) {
      if (value === 'flush') this.getData()
    },
    refund (entity) {
      this.dialogRefund = true
      this.entity = entity
    },
    evaluation (entity) {
      this.dialogEvaluate = true
      this.entity = entity
    },
    visit (entity) {
      this.dialogVisit = true
      this.entity = entity
    },
    employeeMethod (query) {
      if (query !== '') {
        this.employeeLoading = true
        this.getEmployeeAll(query)
      } else {
        this.employees = this.employeeAll
      }
    },
    async getEmployeeAll (value) {
      let {data} = await employee.getEmployeeList({
        orgCode: this.orgCode,
        name: value
      })
      this.employeeLoading = false
      if (this.employeeAll.length === 0) this.employeeAll = data
      this.employees = data
      return data
    },
    setScreeData (val) {
      this.screenData.offBeginTime = val ? dayjs(val[0]).format('YYYY-MM-DD HH:mm:ss') : ''
      this.screenData.offEndTime = val ? dayjs(val[1]).format('YYYY-MM-DD HH:mm:ss') : ''
    },
    async exportExcel () {
      this.exportLoading = true
      await order.getOrderExcelList({
        param: this.screenData
      }, '服务订单')
      this.exportLoading = false
    },
    async getData () {
      this.loading = true
      let {data, page} = await order.getOrderListPage({
        param: this.screenData,
        page: this.page
      })
      this.loading = false
      this.page = page
      this.tableData = data
    },
    handlePayWay (row) {
      let result = this.payWays.find(item => item.dictItemCode === JSON.stringify(row.payMode))
      return result ? result.dictItemName : ''
    },
    screenSubmit () {
      this.page.pageNum = 1
      this.getData()
    },
    resetScreen () {
      this.$refs.screenForm.resetFields()
      this.setScreeData(false)
      this.dateRange = ''
      this.page.pageNum = 1
      this.getData()
    },
    handleSizeChange (arg) {
      this.page.pageSize = arg
      this.getData()
    },
    handleCurrentChange (arg) {
      this.page.pageNum = arg
      this.getData()
    },
    tabSelected (tab) {
      this.screenData.policyRenewStatPeriod = this.tabsData[tab.index].id
      this.page.pageNum = 1
      this.getData()
    },
    openDetail (id) {
      // this.$refs.policyDetail.getData(id)
    },
    detailShowChange (param) {
      this.detailShow = param
    }
  }
}
</script>

<style lang="scss" scoped>
  .state-rem {
    font-size: 13px;
    color: #b4b4b4;
  }
  .excel-left {
    margin-left: 30px !important;
  }
  .my-autocomplete {
    min-width: 232px;
    width: auto !important;
    li {
      line-height: normal;
      padding: 7px;
      .name {
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .addr {
        font-size: 12px;
        color: #b4b4b4;
      }
      .highlighted .addr {
        color: #ddd;
      }
    }
  }
  .detail-list {
    padding: 24px 0;
    *zoom: 1;
    *clear: both;
    &:before,
    &:after {
      display: table;
      clear: both;
      content: "";
    }
    .list-item {
      float: left;
      width: 33.333333333333%;
      font-size: 14px;
      color: #777;
      line-height: 40px;
      span {
        display: inline-block;
        min-width: 90px;
        text-align: right;
      }
    }
  }
</style>
